import { KontoService } from './../../api/konto.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Konto } from 'src/app/api/konto';

@Component({
  selector: 'app-konto',
  templateUrl: './konto.component.html',
  styleUrls: ['./konto.component.scss']
})
export class KontoComponent implements OnInit {
  public konto: Konto;

  constructor(private route: ActivatedRoute, private kontoService: KontoService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let kontoId: number = params['konto'];
      this.kontoService.getKonto(kontoId).subscribe(
        (result) => {
          if (!!result) {
            this.konto = result;
          }
        }
      )
    })
  }

}
